import equalizeHeight from '../utils/equalizeHeight';
import equalizeHeightBreakpoints from '../utils/equalizeHeightBreakpoints';
import equalizeHeightResized from '../utils/equalizeHeightResized';

export default class EqualizeHeight {
  constructor() {
    this.selector = 'body';
  }

  bootstrap() {
    this.runDirectives();
  }

  runDirectives() {
    this.elements = [ ...document.querySelectorAll('[data-af-eq-items]') ];

    if (this.elements.length === 0) {
      return;
    }

    this.elements.forEach(item => {
      const selectors = item.dataset.afEqItems.replace(' ', '').split(',');
      const breakpoints = item.dataset.afEqGroupBy;
      const { columns, width } = equalizeHeightBreakpoints(breakpoints);
      const itemsToEqualize = [];

      selectors.forEach(selector => {
        const element = [ ...item.querySelectorAll(selector) ];

        itemsToEqualize.push(element);
      });

      if (window.innerWidth >= width) {
        itemsToEqualize.forEach(eqThis => {
          equalizeHeight(eqThis, columns);
        });
      }

      itemsToEqualize.forEach(eqThis => {
        equalizeHeightResized(eqThis, breakpoints);
      });
    });
  }
}
